/* Divine Hindu — rows under the product (sections/dh-pdp-rows.liquid), Oct 2026.
   - Remembers the products this shopper opens (this browser only, key "dh_recently_viewed", same list as before).
   - "Recently viewed": builds the cards from /products/<handle>.js when the row comes near the screen.
   - "You may also like": loads Shopify's related products through the product recommendations URL.
   The cards use the same markup as the other product rows, so ADD, − / + and the option chooser come from
   assets/dh-divine-picks.js and the swipe bar / arrows from assets/dh-festive-rows.js. No checkout code here. */
(function () {
  if (window.__dprReady) return;
  window.__dprReady = true;
  var KEY = 'dh_recently_viewed';
  var closedPitruHandles = ["gaya-pind-daan-vishnupad-falgu-akshayavat","sarva-pitru-amavasya-mahalaya-puja-2026","ganga-tarpan-kashi-pitru-paksha","pitru-dosh-nivaran-puja-pitru-paksha-2026","tripindi-shraddha-pishach-mochan-kund-2026","tithi-shraddha-with-pind-daan-2026","narayan-bali-nag-bali-puja-2026","matru-navami-avidhava-navami-shraddha-2026","bharani-shraddha-gaya-2026","ghata-chaturdashi-shraddha-2026","dwadashi-sanyasi-shraddha-2026","pitru-shanti-jaap-pitru-gayatri-vishnu-sahasranama","srirangapatna-mahalaya-amavasya-tarpan-2026"];
  var SKIP = { 'pooja seva': 1, 'online puja': 1, 'pitru paksha puja': 1 };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) {
    var v = (Number(c) || 0) / 100;
    var s = v % 1 ? v.toFixed(2) : String(Math.round(v));
    var parts = s.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '₹ ' + parts.join('.');
  }
  function img(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function readList() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function writeList(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }
  function near(el, fn) {
    var done = false;
    function go() { if (!done) { done = true; fn(); } }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: '700px 0px' });
      io.observe(el.parentNode || el);
    } else { setTimeout(go, 1500); }
  }
  function refresh(row) {
    row.hidden = false;
    if (window.dfbRowsInit) window.dfbRowsInit();
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) document.dispatchEvent(new CustomEvent('dh:cart', { detail: c })); })
      .catch(function () {});
  }

  /* one product card, same markup as snippets/dh-festive-pcard.liquid */
  function card(p, T) {
    if (closedPitruHandles.indexOf(String(p.handle || '')) !== -1) return '';
    if (window.DHIsDIYBead && window.DHIsDIYBead(p)) return '';
    var vs = (p.variants || []).filter(function (v) { return v.available; });
    if (!p.available || !vs.length) return '';
    if (SKIP[String(p.type || '').toLowerCase()]) return '';
    var v = vs.reduce(function (a, b) { return b.price < a.price ? b : a; });
    var multi = (p.variants || []).length > 1;
    var name = String(p.title || '');
    if (name.indexOf('Divine Hindu ') === 0 && name.length > 13) name = name.slice(13);
    var off = 0, save = 0;
    if (v.compare_at_price > v.price) { save = v.compare_at_price - v.price; off = Math.floor(save * 100 / v.compare_at_price); }
    var pic = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
    var meta = multi ? v.title : (p.type || '');
    var url = p.url || ('/products/' + p.handle);
    var h = '<article class="dpx-row dfb-pc" data-pid="' + p.id + '"' + (multi ? ' data-multi' : ' data-vid="' + v.id + '"') + '>' +
      '<div class="dfb-pc__box"><a class="dfb-pc__img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
      (pic ? '<img src="' + esc(img(pic, 360)) + '" srcset="' + esc(img(pic, 240)) + ' 240w, ' + esc(img(pic, 360)) + ' 360w, ' + esc(img(pic, 480)) + ' 480w" sizes="(min-width: 990px) 220px, (min-width: 750px) 30vw, 46vw" width="360" height="360" alt="" loading="lazy" decoding="async">' : '') +
      (off > 0 ? '<span class="dfb-pc__off">' + off + '% OFF</span>' : '') + '</a>' +
      '<div class="dfb-pc__bar"><span class="dfb-pc__meta">' + esc(meta) + '</span><div class="dpx-row__act dfb-pc__act">' +
      '<button type="button" class="dpx-add" data-dpx-add aria-label="' + esc(T.add + ': ' + name) + '">' + esc(T.add) +
      (multi ? '<small class="dfb-pc__opts">' + esc(T.opts.replace('{n}', p.variants.length)) + '</small>' : '') + '</button>' +
      '<div class="dpx-step" hidden><button type="button" data-dpx-dec aria-label="' + esc(T.less + ': ' + name) + '">&minus;</button><span data-dpx-qty aria-live="polite">0</span><button type="button" data-dpx-inc aria-label="' + esc(T.more + ': ' + name) + '">+</button></div>' +
      '</div></div></div>' +
      '<div class="dfb-pc__body"><div class="dfb-pc__price"><b>' + money(v.price) + '</b>' + (off > 0 ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '</div>' +
      (save > 0 ? '<span class="dfb-pc__save">' + money(save) + ' OFF</span>' : '') +
      '<a class="dpx-row__title dfb-pc__title" href="' + esc(url) + '">' + esc(name) + '</a></div>';
    if (multi) {
      var j = { title: name, url: url, img: p.featured_image ? img(p.featured_image, 240) : '', variants: p.variants.map(function (x) {
        var o = x.compare_at_price > x.price ? Math.floor((x.compare_at_price - x.price) * 100 / x.compare_at_price) : 0;
        return { id: x.id, t: x.title, p: money(x.price), c: o > 0 ? money(x.compare_at_price) : '', o: o, a: !!x.available };
      }) };
      h += '<script type="application/json" data-dpx-json>' + JSON.stringify(j).replace(/</g, '\\u003c') + '</script>';
    }
    return h + '</article>';
  }

  function setup(root) {
    if (!root || root.__dpr) return;
    root.__dpr = true;
    var T = { add: root.getAttribute('data-t-add') || 'ADD', opts: root.getAttribute('data-t-opts') || '{n} options',
              less: root.getAttribute('data-t-less') || 'One less', more: root.getAttribute('data-t-more') || 'One more' };
    var cur = root.getAttribute('data-handle') || '';

    /* remember this product */
    var list = readList().filter(function (h) { return h && h !== cur && h !== 'siddhi' && (!window.DHIsDIYBead || !window.DHIsDIYBead(h)); });
    var others = list.slice();
    if (cur && (!window.DHIsDIYBead || !window.DHIsDIYBead(cur))) { list.unshift(cur); writeList(list.slice(0, 16)); }

    /* recently viewed */
    var rv = root.querySelector('[data-dpr-recent]');
    if (rv && others.length) {
      near(rv, function () {
        var max = Number(rv.getAttribute('data-max')) || 10;
        var rail = rv.querySelector('[data-dpr-rail]');
        Promise.all(others.slice(0, max + 4).map(function (h) {
          return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (ps) {
          var html = '', n = 0;
          ps.forEach(function (p) { if (!p || n >= max) return; var c = card(p, T); if (c) { html += c; n++; } });
          if (n) { rail.innerHTML = html; refresh(rv); }
        });
      });
    }

    /* you may also like */
    var rc = root.querySelector('[data-dpr-reco]');
    if (rc) {
      near(rc, function () {
        var max = Number(rc.getAttribute('data-max')) || 10;
        fetch(rc.getAttribute('data-url'), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (t) {
            if (!t) return;
            var box = document.createElement('div'); box.innerHTML = t;
            var cards = [].slice.call(box.querySelectorAll('[data-dpr-reco-cards] > .dfb-pc')).slice(0, max);
            if (!cards.length) return;
            var rail = rc.querySelector('[data-dpr-rail]');
            cards.forEach(function (c) { rail.appendChild(c); });
            refresh(rc);
          }).catch(function () {});
      });
    }
  }
  function init() { [].forEach.call(document.querySelectorAll('[data-dpr]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target && e.target.querySelector('[data-dpr]'); if (s) setup(s); });
})();
